namespace TabAurous.OMS {
    export interface MetalRateMasterForm {
        CompanyId: Serenity.LookupEditor;
        RateTypeId: Serenity.LookupEditor;
        MetalTypeId: Serenity.LookupEditor;
        RateOn: MetalRateEditor;
        CurrencyId: Serenity.LookupEditor;
        Rate: Serenity.DecimalEditor;
        LossPercent: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        IsSysParam: Serenity.StringEditor;
    }

    export class MetalRateMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.MetalRateMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MetalRateMasterForm.init)  {
                MetalRateMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = MetalRateEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = s.StringEditor;

                Q.initFormType(MetalRateMasterForm, [
                    'CompanyId', w0,
                    'RateTypeId', w0,
                    'MetalTypeId', w0,
                    'RateOn', w1,
                    'CurrencyId', w0,
                    'Rate', w2,
                    'LossPercent', w2,
                    'FromDate', w3,
                    'ToDate', w3,
                    'IsSysParam', w4
                ]);
            }
        }
    }
}
